import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {throwError as observableThrowError, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {Subject} from 'rxjs/Rx';
import * as socketio from 'socket.io-client';

@Injectable({providedIn: 'root'})
export class AcoesService {
  private apiUrl = environment.apiUrl;
  acoesUrl = `${this.apiUrl}public/acoes/`;

  constructor(private _http: HttpClient) {
  }

  getAcoesEmpresa(empresaId): Observable<any[]> {
    return this._http.get(`${this.acoesUrl}empresa/${empresaId}`)
      .pipe(map(data => {
        return <any[]>data;
      }));
  }

  getAcoesEmpresaUpdates() {
    const socket = socketio(this.apiUrl);
    const acoesSub = new Subject<{}>();
    const acoesSubObservable = Observable.from(acoesSub);

    socket.on('acoes', (acoes) => {
      acoesSub.next(acoes);
    });

    return acoesSubObservable;
  }

  getAcoesLoja(lojaId, empresaId): Observable<any[]> {
    return this._http.get(`${this.acoesUrl}loja/${empresaId}/${lojaId}`)
      .pipe(map(data => {
        return <any[]>data;
      }));
  }

  getAcoesUsuario(usuarioId, empresaId): Observable<any[]> {
    return this._http.get(`${this.acoesUrl}usuario/${empresaId}/${usuarioId}`)
      .pipe(map(data => {
        return <any[]>data;
      }));
  }

  insertAcao(empresaId, acao) {
    return this._http.post(`${this.acoesUrl}acao/${empresaId}`, acao)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  insertAcoes(empresaId, acoes) {
    return this._http.post(`${this.acoesUrl}acoes/${empresaId}`, acoes)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  removeAcoes(empresaId, arrayIds): Observable<any[]> {
    const ids = JSON.stringify(arrayIds);
    return this._http.delete(`${this.acoesUrl}${empresaId}/${ids}`)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  getAcoesByStatusEmpresa(empresaId, dataInicial, dataFinal, meses, anos): Observable<any[]> {
    meses = JSON.stringify(meses);
    anos = JSON.stringify(anos);
    return this._http.get(`${this.acoesUrl}acoesByStatusEmpresa/${empresaId}/${dataInicial}/${dataFinal}/${meses}/${anos}/`)
      .pipe(map((data) => {
        const arr = [];
        for (const key in data[0]) {
          if (data[0].hasOwnProperty(key) && data[0][key]) {
            arr.push({status: key, val: data[0][key]});
          }
        }
        return <any>arr;
      }));
  }

  getAcoesMinMaxDate(empresaId): Observable<{}> {
    return this._http.get(`${this.acoesUrl}acoesMinMaxDate/${empresaId}`)
      .pipe(map((minMax) => {
        return <{}>minMax;
      }));
  }

  getAcoesByStatusLojas(empresaId, dataInicial, dataFinal, meses, anos): Observable<any[]> {
    meses = JSON.stringify(meses);
    anos = JSON.stringify(anos);
    return this._http.get(`${this.acoesUrl}acoesByStatusLojas/${empresaId}/${dataInicial}/${dataFinal}/${meses}/${anos}/`)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  getAcoesByDimensao(empresaId, dataInicial, dataFinal, meses, anos): Observable<any[]> {
    meses = JSON.stringify(meses);
    anos = JSON.stringify(anos);
    return this._http.get(`${this.acoesUrl}acoesByDimensaoEmpresa/${empresaId}/${dataInicial}/${dataFinal}/${meses}/${anos}/`)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  acoesByStatusMesEmpresa(empresaId, dataInicial, dataFinal, meses, anos): Observable<any[]> {
    meses = JSON.stringify(meses);
    anos = JSON.stringify(anos);
    return this._http.get(`${this.acoesUrl}acoesByStatusMesEmpresa/${empresaId}/${dataInicial}/${dataFinal}/${meses}/${anos}/`)
      .pipe(map((data) => {
        return <any>data;
      }));
  }


  getAcoesByStatusResponsaveis(empresaId, dataInicial, dataFinal, meses, anos): Observable<any[]> {
    meses = JSON.stringify(meses);
    anos = JSON.stringify(anos);
    return this._http.get(`${this.acoesUrl}acoesByStatusResponsaveis/${empresaId}/${dataInicial}/${dataFinal}/${meses}/${anos}/`)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  private handleError(error) {
    return observableThrowError(error.json().error || 'Server error');
  }
}
